// removed by extract-text-webpack-plugin
module.exports = {"VideoProject":"src-components-videos----video-project-module---VideoProject---sLLI0","VideoProject__heading":"src-components-videos----video-project-module---VideoProject__heading---314bR","VideoProject__video":"src-components-videos----video-project-module---VideoProject__video---2b_LW","spinAround":"src-components-videos----video-project-module---spinAround---3-P0F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/videos/video-project.module.scss
// module id = 457
// module chunks = 169559349407212